export default {"src":"/_next/static/media/0x8d2cb35893c01fa8b564c84bd540c5109d9d278e.7b531822.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};